// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6862 ? "4ec222fc" : chunkId) + "." + {"6862":"a53e74302565710e","7373":"c5b2225aea8ac4fd","7518":"439814b993027330"}[chunkId] + ".js";
};